import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BsDatepickerModule, TooltipModule} from 'ngx-bootstrap';
import { DatagridBaseComponent } from './datagrid.component';
import {DatagridListComponent} from './datagrid-list.component';
import {DatagridSearchComponent} from './datagrid-search.component';
import {SharedModule} from '../shared/shared.module';
import {DatagridService} from './datagrid.service';
import {DatagridEmployeeComponent} from './datagrid-employee-component';

@NgModule({
  declarations: [
    DatagridBaseComponent,
    DatagridEmployeeComponent,
    DatagridListComponent,
    DatagridSearchComponent
  ],
  exports: [
    DatagridBaseComponent,
    DatagridEmployeeComponent,
    DatagridListComponent,
    DatagridSearchComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    BsDatepickerModule.forRoot(),
    TooltipModule.forRoot(),
  ],
  providers: [
    DatagridService
  ]
})
export class DatagridModule { }



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/datagrid/datagrid.module.ts